import Axios from 'axios';

export default function axios() {
    return Axios.create({
        baseURL: "https://equipment-rental-backend.herokuapp.com",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('token'),
        }
    });
}